import React, { Component } from 'react';
import { Modal, Button, Input, message } from 'antd';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Wrapper from './style';
import { EXCHANGE_CARD_ICON_BLACK, XHT_ICON_LIGHT, XHT_ICON } from '../../config/media';
import { withdrawXht, cancelPledge } from '../../common/fetch';

class Pledge extends Component {
	state = {
		check: false,
		is_public: false,
		amount: '0',
		checked: false,
		error: false,
		step: 1,
		isConfirmed: false,
		address: "",
		isAddress: false
	};

	handleCheck = () => {
		this.setState({ check: !this.state.check });
	};

	handleSubmit = async () => {
		const { collateral } = this.props;
		const body = {
			exchange_id: collateral.id,
			address: this.state.address
		};
		try {
			await withdrawXht(body);
			this.props.getStakeAllData();
			this.setState({ step: 5 });
		} catch (error) {
			console.error(error);
			if (error && error.data && error.data.message) {
				message.error(error.data.message);
			}
		}
	};

	handleChange = (e) => {
		const { user } = this.props;
		const { name, value } = e.target;
		if (value === '-') {
			return;
		}
		this.setState({ [name]: value }, () => {
			if (isNaN(parseFloat(value))) {
				this.setState({ error: 'Just fill the Amount' });
			} else if (parseFloat(value) <= 0) {
				this.setState({
					error: "It's impossible to collateral less zero."
				});
			} else if (parseFloat(value) > user.balance.xht_available) {
				this.setState({ error: 'Not Enough the Amount' });
			} else {
				this.setState({ error: false });
			}
		});
	};

	handleSwitch = (bool) => {
		this.setState({ is_public: bool });
	};

	onCancel = () => {
		this.setState(
			{ check: false, is_public: false, amount: '', error: false, step: 1 },
		);
		this.props.onCancel();
	};

	handleInput = (e) => {
		if ((this.props.type === "cancel-remove" && e.target.value === "CANCEL REMOVE")|| (this.props.type === "remove" && e.target.value === "REMOVE")) {
			this.setState({ isConfirmed: true })
		} else {
			this.setState({ isConfirmed: false })
		}
	}

	handleAddressInput = (e) => {
		const { name, value } = e.target;
		if (e.target.value) {
			this.setState({ [name] : value, isAddress: true })
		} else {
			this.setState({ isAddress: false })
		}
	}

	handleCancel = async () => {
		const { collateral } = this.props;
		const body = {
			exchange_id: collateral.id
		}
		try {
			await cancelPledge(body);
			this.props.getStakeAllData()
			this.setState({ step: 5 });
		} catch (error) {
			console.error(error);
			if (error && error.data && error.data.message) {
				message.error(error.data.message);
			}
		}
	};

	renderPopup = () => {
		const { collateral, amount, type, cancelData } = this.props;
		const { error, step, isConfirmed, address, isAddress } = this.state;
		const uid = collateral ? (collateral.id % 6) + 1 : null;
		const total_time = moment(cancelData.close_timestamp).diff(moment(cancelData.updated_at), 'days');
		// const time_in_progress = moment().diff(moment(cancelData.updated_at), 'days');
		// const time_left = Math.floor(( time_in_progress / total_time ) * 100);

		switch (step) {
			case 2:
				return (
					<Wrapper>
						<div className='info-box step2'>
							<h2>Receiving address</h2>
							<div className='d-flex'>
								<b>Your XHT Balance:</b>
								<img src={XHT_ICON} className='xht-icon' alt='XHT' />
							</div>
							<div className='address-content'>
								<span>Address to remove XHT to:</span>
								<br />
								<Input
									name="address"
									onChange={this.handleAddressInput}
								/>
							</div>
							<div className='btn-wrapper'>
								<Button
									block
									type='primary'
									onClick={() => this.setState({ step: 1 })}
								>
									Back
								</Button>
								<Button
									block
									type='primary'
									disabled={!isAddress}
									onClick={() => this.setState({ step: 3 })}
								>
									Proceed
								</Button>
							</div>
						</div>
					</Wrapper>
				);
			case 3:
				return (
					<Wrapper>
						<div className='step3-container'>
							<h2>Check & confirm</h2>
							<div>
								Check the details of XHT stake removal.
							</div>
							<div className='box-container'>
								<div className='box-title'>Stake details</div>
								<div className='flex-container'>
									<img
										src={EXCHANGE_CARD_ICON_BLACK[uid]}
										alt='EXCHANGE_CARD_ICON_BLACK'
									/>
									<div>
										<b>Project removing from:</b>{' '}
										<span>{collateral ? collateral.display_name : ""}</span>
									</div>
									<div>
										<b>Amount to remove:</b> <span>{amount}</span>
									</div>
									<div>
										<b>Removal process:</b> <span>2,102,400 Ethereum blocks (~1 year)</span>
									</div>
									<div>
										<b>Address:</b> <span>{address}</span>
									</div>
								</div>
							</div>
							<div className='btn-wrapper'>
								<Button
									block
									type='primary'
									onClick={() => this.setState({ step: 2 })}
								>
									Back
								</Button>
								<Button
									block
									type='primary'
									onClick={() => this.setState({ step: 4 })}
								>
									Proceed
								</Button>
							</div>
						</div>
					</Wrapper>
				);
			case 4:
				return (
					<Wrapper>
						<div className='insufficient-header'>
							<h2>Are you sure?</h2>
							{type === "cancel-remove"
								?
								<p>
									Please acknowledge that canceling the removal process resets
									the removal period taken and if you stake again it would start the waiting period for staking over.
								</p>
								:
								<p>
									Please acknowledge that you understand that removing XHT
									stake is roughly a one year process during which all earnings
									will halt.
								</p>
							}
						</div>
						{type === "cancel-remove"
							?
								<div className='step4-content'>
									<b>Type 'CANCEL REMOVE' to confirm</b>
									<Input onChange={this.handleInput} />
									<div className='btn-wrapper'>
										<Button
											block
											type='primary'
											onClick={() => this.setState({ step: 1 })}
										>
											Back
										</Button>
										<Button
											block
											type='primary'
											disabled={!isConfirmed}
											onClick={isConfirmed ? this.handleCancel : null}
										>
											Cancel removal
										</Button>
									</div>
								</div>
							:
								<div className='step4-content'>
									<b>Type 'REMOVE' to confirm</b>
									<Input onChange={this.handleInput} />
									<div className='btn-wrapper'>
										<Button
											block
											type='primary'
											onClick={() => this.setState({ step: 3 })}
										>
											Back
										</Button>
										<Button
											block
											type='primary'
											disabled={!isConfirmed}
											onClick={isConfirmed ? this.handleSubmit : null}
										>
											remove stake
										</Button>
									</div>
								</div>
						}
					</Wrapper>
				);
			case 5:
				return (
					<Wrapper>
						<div className='info-box'>
							<div className='collater-info'>
								<div className='img-wrapper'>
									<img
										src={EXCHANGE_CARD_ICON_BLACK[uid]}
										alt='EXCHANGE_CARD_ICON_BLACK'
									/>
								</div>
								<div className='stat-info'>
									<div className='small-txt'>
										<b>Project:</b> {collateral ? collateral.display_name : ""}
										{type === "cancel-remove"
											?
												<div>
													<div>
														<b>XHT restaked:</b>{' '}
														<img
															src={XHT_ICON_LIGHT}
															alt='xth'
															className='xht-icon'
														/>{' '}
														<span>{collateral.pledges.mine}</span>
													</div>
													<div>
														<b>Removal reset to:</b> <span>1 year</span>
													</div>
												</div>
											: 
												<div>
													<div>
														<b>XHT to be removed:</b>{' '}
														<img
															src={XHT_ICON_LIGHT}
															alt='xth'
															className='xht-icon'
														/>{' '}
														<span>{collateral.pledges.mine}</span>
													</div>
													<div>
														<b>Receiving address:</b> <span>{address}</span>
													</div>
													<div>
														<b>Removal process:</b> <span>{total_time} days left</span>
													</div>
												</div>
										}
										<Link to='wallet?type=2'>
											View staking details
										</Link>
									</div>
								</div>
							</div>

							{type === "cancel-remove"
								?
								<p className='footer'>
									The XHT removal process is canceled.
								</p>
								:
								<p className='footer'>
									The XHT removal process is started. The earnings halt.
									You can cancel the removal process anytime.
								</p>
							}
							
							<Button
								block
								type='primary'
								disabled={error}
								onClick={this.onCancel}
							>
								Close
							</Button>
						</div>
					</Wrapper>
				);
			case 1:
			default:
				return (
					<Wrapper>
						{type === "cancel-remove"
							?
								<div>
									<div className='collateral-header'>
										<img src={XHT_ICON} alt='xth' />
										<h2>Cancel removal process</h2>
										<p>
											You can at anytime cancel the removal process but note this will reset
											any remaining time left on your current removal process timer.
										</p>
										<p>
											Canceling your removal will return the amount to the project collateral
											staking and resume all your earning streams.
										</p>
									</div>

									<div className='info-box'>
										<div className='collater-info'>
											<div>
												<img
													src={EXCHANGE_CARD_ICON_BLACK[uid]}
													alt='EXCHANGE_CARD_ICON_BLACK'
												/>
												<p>
													<b>{collateral ? collateral.display_name : ""}</b>
												</p>
											</div>
											<div className='stat-info'>
												<p className='no-exchange'>
													<b>Amount to returned staking:</b> <span>{cancelData.amount}</span>
													<br/>
													<div className="m-1">
														<b>Earning streams to resume:</b>
														<br />
														1. Network trade fees
														<br />
														2. Newly minted XHT tokens
													</div>
												</p>
											</div>
										</div>
										<div className='btn-wrapper'>
											<Button block type='primary' onClick={this.onCancel}>
												Back
											</Button>
											<Button
												block
												type='primary'
												disabled={error}
												onClick={() => this.setState({ step: 4 })}
											>
												I understand. Proceed.
											</Button>
										</div>
									</div>
								</div>
							:
								<div>
									<div className='collateral-header'>
										<img src={XHT_ICON} alt='xth' />
										<h2>XHT stake removal process</h2>
										<p>
											At anytime you can begin the XHT removal process of XHT from any
											projects but note the process takes 2,102,400 Ethereum blocks (~1 year) during which all new
											earnings will be halted. You may cancel the removal process at anytime
											and return the amount to staking.
										</p>
									</div>

									<div className='info-box'>
										<div className='collater-info'>
											<div>
												<img
													src={EXCHANGE_CARD_ICON_BLACK[uid]}
													alt='EXCHANGE_CARD_ICON_BLACK'
												/>
												<p>
													<b>{collateral ? collateral.display_name : ""}</b>
												</p>
											</div>
											<div className='stat-info'>
												<p className='no-exchange'>
													<b>Amount to remove:</b> <span>{amount}</span>
													<br />
													<div className="m-1">
														<b>Earning to be halted:</b>
														<br />
														1. Network trade fees
														<br />
														2. Newly minted XHT tokens
													</div>
												</p>
												<p className='medium-txt'>
													<b>Removal process:</b> <span>2,102,400 Ethereum blocks (~1 year)</span>
												</p>
											</div>
										</div>
										<div className='btn-wrapper'>
											<Button block type='primary' onClick={this.onCancel}>
												Back
											</Button>
											<Button
												block
												type='primary'
												disabled={error}
												onClick={() => this.setState({ step: 2 })}
											>
												I understand. Proceed.
											</Button>
										</div>
									</div>
								</div>
						}
					</Wrapper>
				);
		}
	};

	render () {
		const { visible, onOk } = this.props;
		const { step } = this.state;
		return (
			<Modal
				visible={visible}
				footer={null}
				bodyStyle={{ padding: 0 }}
				width={step === 2 || step === 3 || step === 5 ? 450 : 550}
				onOk={onOk}
				onCancel={this.onCancel}
			>
				<Wrapper>
					{this.renderPopup()}
				</Wrapper>
			</Modal>
		);
	}
}

export default Pledge;
